import Swal from "sweetalert2/dist/sweetalert2.js";
// window._ = require('lodash')
import Home from "./home";
/* import Category from './category' */
/* import Mmenu from 'mmenu-js' */
import Product from "./product";
import MobileDetect from "mobile-detect";
import TopMenu from "./menu";
import Address from "./address";
import AddressMap from "./account";
import EvAutocomplete from "./autocomplete";
import HeadCart from "./cart";
import QuickBuyVue from "./quick";
import Store from "./store";

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");
    // Bootstrap lib
    require("bootstrap");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

window.md = new MobileDetect(window.navigator.userAgent);

document.addEventListener("DOMContentLoaded", () => {
    /*         new Mmenu("#responsive-menu", {
            "pageScroll": {
                "scroll": true,
            },
            "extensions": [
                "shadow-page"
            ]
        }); */
    // Carrello header
    if (document.getElementById("head-cart")) {
        window.Cart = HeadCart("head-cart");
    }
    // Pagina Carrello
    if (document.getElementById("page-cart")) {
        window.PageCart = HeadCart("page-cart");
    }
    // Quick Buy
    if (document.getElementById("quick-buy-container")) {
        window.QuickBuy = QuickBuyVue();
    }
    // Pagina checkout
    if (document.getElementById("summary")) {
        window.CheckoutPage = HeadCart("summary");
    }

    // newsletter
    window.$(".form-newsletter").on("submit", function(event) {
        event.stopPropagation();
        event.preventDefault();
        var form = $(this);
        let uniqueid =uuidv4();
        grecExecute(function() {
            $.post(
                window.PlUs.api.newsletter,
                form.serialize(),
                function(data) {
                    if (data.result) {
                        Swal.fire({
                            icon: "success",
                            title: data.msg,
                            text: ""
                        });
                    } else {
                        Swal.fire({
                            icon: "info",
                            title: data.msg,
                            text: ""
                        });
                    }
                },
                "json"
            );
            // PIXEL FACEBOOK REGISTRAZIONE NEWSLETTER - LEAD
            fbq("track", "Lead",{},{eventID: uniqueid});
            //GA4
            dataLayer.push({
                event: "generate_lead",
                value: 1,
                currency: "EUR",
                eventID: uniqueid
            });
        });
    });
});

window.Swal = Swal;
// sweetalert2
// Alert
window.Swal = function(list, title, textFooter) {
    let config = {
        icon: "info",
        title: window.PlUs.strings["attantion"],
        text: ""
    };
    if (title !== undefined) {
        config["title"] = title;
    }
    if (textFooter !== undefined) {
        config["footer"] = textFooter;
    }
    list.forEach(element => {
        config["text"] += element + " ";
    });
    Swal.fire(config);
};
// Notification
window.Notification = function(icon, title) {
    if (icon == undefined) {
        icon = "info";
    }
    Swal.fire({
        position: "center",
        icon: icon,
        title: title,
        showConfirmButton: false,
        showCloseButton: true,
        timer: 6000
    });
};

window.Store = Store;
window.Home = Home;
window.Product = Product;
window.TopMenu = TopMenu();
window.Address = Address;
window.AddressMap = AddressMap;
window.EvAutocomplete = EvAutocomplete;
